<template>
  <v-row justify="center">
    <v-dialog v-model="unitsDialog" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Select Institution</span>
        </v-card-title>
        <v-card-text class="mt-2 mb-n2">
          <v-form ref="institutionForm">
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete
                  :items="accreditedInstitute"
                  :item-text="(item) => item.name"
                  :item-value="(item) => item.code"
                  v-model="setaccreditedInstitute"
                  @input="setAccreditedInstituteFunc($event)"
                  v-if="!other"
                  ref="institute"
                  label="Accredited Institute"
                  class="label"
                  clearable
                  @click:clear="clearInstitute"
                  open-on-clear
                  outlined
                  dense
                >
                  <template v-slot:selection="{ item }">
                    <span class="selectWrap">
                      {{ item.code === "OTHER" ? isOther() : item.name }}
                    </span>
                  </template>
                </v-autocomplete>
                <v-text-field
                  :disabled="formData.examExemptionLines.isNotExempted"
                  class="label"
                  v-else
                  label="Accredited Institute"
                  dense
                  v-model="setaccreditedInstitute"
                  @input="setCustomInstituteFunc($event)"
                  clearable
                  @click:clear="clearCustomInstitute"
                  outlined
                  ref="otherInstitute"
                />
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete
                  :items="awardingBodies"
                  :item-text="(item) => item.description"
                  :item-value="(item) => item.code"
                  v-model="setawardingBodies"
                  @input="setAwardingBodiesFunc($event)"
                  outlined
                  clearable
                  open-on-clear
                  dense
                  class="label"
                >
                  <template v-slot:label>
                    <span>Awarding Bodies</span>
                  </template>
                  <template v-slot:selection="{ item }">
                    <span class="selectWrap">
                      {{ item.description }}
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="error" text @click="closeDialog"> Close </v-btn> -->
          <v-btn color="primary" text @click="closeDialog"> done </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
/* eslint-disable */
export default {
  name: "institutionDialog",
  props: {
    InstitutionDialogBox: Boolean,
    formData: Object,
    currentUnit: Object,
  },
  data() {
    return {
      other: false,
      defaultItem: {
        accreditedInstituteCode: "",
        accreditedInstituteName: "",
      },
    };
  },
  computed: {
    unitsDialog: {
      get() {
        return this.InstitutionDialogBox;
      },
      set(value) {
        this.setInstitutionModal(value);
      },
    },
    awardingBodies() {
      return this.$store.getters["Exemption/exemptionGetter"]("awardingBodies");
    },
    accreditedInstitute() {
      return this.$store.getters["Exemption/exemptionGetter"](
        "accreditedInstitute",
      );
    },
    rules() {
      return {
        required: [(v) => !!v || "field is required"],
      };
    },
    setaccreditedInstitute: {
      get() {
        let instituteCode = this.currentUnit.accreditedInstituteCode;
        if (instituteCode === "OTHER") {
          return this.currentUnit.accreditedInstituteName;
        } else {
          return instituteCode;
        }
      },
      set(value) {
        this.currentUnit.accreditedInstituteCode = value;
      },
    },
    setawardingBodies: {
      get() {
        return this.currentUnit.awardingBodyCode;
      },
      set(value) {
        this.currentUnit.awardingBodyCode = value;
      },
    },
  },
  methods: {
    setInstitutionModal(value) {
      this.$emit("setInstitutionModal", value);
    },
    closeDialog: function () {
      if (
        !this.currentUnit.accreditedInstituteCode &&
        !this.currentUnit.awardingBodyCode
      ) {
        Event.$emit("ApiError", "Atleast one field has to filled");
      } else if (
        this.currentUnit.accreditedInstituteCode &&
        this.currentUnit.awardingBodyCode
      ) {
        Event.$emit("ApiError", "Only one is required");
      } else {
        this.unitsDialog = false;
        this.currentUnit = Object.assign({}, this.defaultItem);
      }
    },
    isOther() {
      this.other = true;
      this.$nextTick(() => this.$refs.otherInstitute.focus());
    },
    clearCustomInstitute() {
      this.other = false;
      delete this.currentUnit.accreditedInstituteCode;
      delete this.currentUnit.accreditedInstituteName;
      this.$nextTick(() => this.$refs.institute.focus());
    },
    clearInstitute() {
      delete this.currentUnit.accreditedInstituteCode;
      delete this.currentUnit.accreditedInstituteName;
    },
    setAccreditedInstituteFunc(event) {
      let currentInstitute = this.accreditedInstitute
        ? this.accreditedInstitute
            .filter((item) => {
              return item.code === event;
            })
            .shift()
        : "";
      this.formData.examExemptionLines.map((el) => {
        if (el.code === this.currentUnit.code) {
          el.accreditedInstituteCode = event;
          el.accreditedInstituteName = currentInstitute
            ? currentInstitute.name
            : "";
          return el;
        }
      });
    },
    setAwardingBodiesFunc(event) {
      this.formData.examExemptionLines.map((el) => {
        if (el.code === this.currentUnit.code) {
          el.awardingBodyCode = event;
          return el;
        }
      });
    },
    setCustomInstituteFunc(event) {
      this.formData.examExemptionLines.map((el) => {
        if (el.code === this.currentUnit.code) {
          el.accreditedInstituteCode = "OTHER";
          el.accreditedInstituteName = event;
          return el;
        }
      });
    },
  },
  watch: {
    currentUnit: {
      handler: function () {
        this.currentUnit.accreditedInstituteCode === "OTHER"
          ? (this.other = true)
          : (this.other = false);
      },
    },
  },
};
</script>
